<template>
    <div :style="[{'font-family': 'sans-serif'}, {'margin': '10px'}, !isLastPage ? {'break-after': 'page'} : {},]">
        
        <v-card>
            <v-container fluid grid-list-xl :style="[isA5Format ? {'height': '203mm'} : {'height':'287mm'}] ">
                <v-layout row wrap>
                    
                    <!-- Show the canceled label if the invoice is canceled -->
                    <div v-if="isInvoiceCanceled" style="position: absolute; left: 50%; top: 40%">
                        <div style="position: relative; left: -50%; bottom: 60%; border:1px solid red; border-radius: 5px; padding: 5px;transform: rotate(-45deg); opacity: 0.4">
                            <span style="font-size: 28px; color: red">Documento Anulado</span>
                        </div>
                    </div>
                    
                    <!-- Invoice Header -->
                    <v-flex xs12 pa-0 ma-0 style=" position: relative; top: 0%; right: 0%; left:0%;">
                        <invoice-header
                            :fetchedInvoice="fetchedInvoiceReceipt"
                            :invoicePrintLabel="invoicePrintLabel"
                            :isInvoiceA5Format="isA5Format"
                        ></invoice-header>
                    </v-flex>

                    
                    <!-- Invoice Body -->
                    <v-flex xs12 pa-0 ma-0>
                        <invoice-receipt-body
                            :fetchedInvoiceReceipt="fetchedInvoiceReceipt"
                            :sellLines="sellLines"
                            :currentPage="currentPage"
                            :totalPage="totalPage"
                            :isInvoiceCanceled="isInvoiceCanceled"
                            :isInvoiceA5Format="isA5Format"
                        ></invoice-receipt-body>
                    </v-flex>

                    <!-- Invoice Total Value -->
                    <v-flex xs12 pa-0 ma-0 v-if="currentPage === totalPage">
                        <invoice-total-value
                            :fetchedInvoice="fetchedInvoiceReceipt"
                            :sellLines="sellLines"
                            :total="getTotal"
                            :isInvoiceA5Format="isA5Format"
                        ></invoice-total-value>
                    </v-flex>

                    <!--Footer-->
                    <!-- Invoice Footer -->
                    <v-flex xs12 pa-0 ma-0 style="position: absolute; bottom: 0%">
                        <invoice-footer
                            :isInvoiceA5Format="isA5Format"
                        ></invoice-footer>
                    </v-flex>

                    <v-flex xs12 v-if="fetchedInvoiceReceipt.detail">
                        <v-divider></v-divider>
                        <p style="font-size: 12px; margin-bottom: 2px">Obs: {{fetchedInvoiceReceipt.detail}}</p>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-card>
                                        
    </div>
</template>

<script>
    import {Types} from "../../../config";
    import {mapGetters} from "vuex";
    import InvoiceHeader from "../InvoicePaper/InvoiceHeader.vue";
    import InvoiceReceiptBody from "./InvoiceReceiptBody.vue";
    import InvoiceTotalValue from "../InvoicePaper/InvoiceTotalValue.vue";
    import InvoiceFooter from "../InvoicePaper/InvoiceFooter.vue";

    export default {

        data(){
            return {
                
            }
        },

        components: {
            InvoiceHeader,
            InvoiceTotalValue,
            InvoiceReceiptBody,
            InvoiceFooter,
        },

        props:{
            currentPage: {
                type: Number,
                default: 0,
            },
            totalPage: {
                type: Number,
                default: 0,
            },
            invoicePrintLabel: {
                type: String,
                default: ""
            },
            fetchedInvoiceReceipt: {
               type: Object,
               default: () => ({}),
            },
            sellLines: {
                type: Array,
                default: () => [],
            },
            isA5Format: {
                type: Boolean,
                default: false,
            },
            isInvoiceCanceled: {
                type: Boolean,
                default: false,
            },
            
        },

        methods:{
            getEmail(json){
                try{
                    return json[0].email;
                }catch (e) {
                    return ""
                }
            },
            getNibFormated(nib, nib_name){
                let nibRes = '';
                nibRes = nib_name ? "Nib_"+nib_name+": " : "Nib: ";
                return nib ? nibRes += nib : '';

            },
            getPhone(json){
                let mobile_phone = '', phone = '';
                try{
                    mobile_phone = json[0].mobile_phone;
                    phone = json[0].phone;

                    if(phone === null) phone = '';
                    if(mobile_phone === null) mobile_phone = '';
                }catch (e) {return ""}

                if(mobile_phone && phone)
                    return phone+" / "+mobile_phone;
                else if(!mobile_phone && !phone)
                    return '';
                else
                    return phone+""+mobile_phone;
            },

            getCompany(){
                let res = '';
                try{
                    res = this.fetchedInvoiceReceipt.sell.company;
                    res = !res ? this.selectedCompany : res;
                }catch (e) {
                    res = this.selectedCompany;
                }
                return res;
            },

            getClient(){
                let res = '';
                try{
                    res = this.fetchedInvoiceReceipt.sell.client;
                    res = !res ? this.selectedClient : res;
                }catch (e) {
                    res = this.selectedClient;
                }
                return res;
            },
        },

        computed: {
            ...mapGetters([
                'loggedUser',
                'getToken',
            ]),

            isLastPage(){
                return this.currentPage === this.totalPage;
            },

            selectedCompany: {
                get(){
                    return this.$store.getters.getSelectedCompany;
                },
                set(value){
                    this.$store.dispatch('setSelectedCompany', value);
                }
            },

            getCurrency(){
                try {
                    if(this.fetchedInvoiceReceipt.sell.types_currency_id === Types.currency.ECV) return 'ECV';
                    if(this.fetchedInvoiceReceipt.sell.types_currency_id === Types.currency.DOLLAR) return 'Dollar';
                    if(this.fetchedInvoiceReceipt.sell.types_currency_id === Types.currency.EURO) return 'Euro';
                    // return this.fetchedInvoiceReceipt.sell.type_currency.name;
                    return '';
                }catch (e) {
                    return '$$$';
                }
            },

            getNib(){
                let res = '';
                try{
                    res = this.getCompany().nib_bi;
                }catch (e) {/*Do nothing*/}
                return res;
            },
            getPrimaryNib(){
                let nib = '', nib_name = '';
                try{
                    try { nib = this.fetchedInvoiceReceipt.sell.company.nib_bi; }catch (e) { /*Do nothing*/ }
                    try { nib_name = this.fetchedInvoiceReceipt.sell.company.nib_bi_name; }catch (e) { /*Do nothing*/ }
                    return this.getNibFormated(nib, nib_name);
                }catch (e) { return ''; }
            },
            getSecondNib(){
                let nib = '', nib_name = '';
                try{
                    try { nib = this.fetchedInvoiceReceipt.sell.company.nib_bi2; }catch (e) { /*Do nothing*/ }
                    try { nib_name = this.fetchedInvoiceReceipt.sell.company.nib_bi2_name; }catch (e) { /*Do nothing*/ }
                    return this.getNibFormated(nib, nib_name);
                }catch (e) { return ''; }
            },

            getCompanyEmail(){
                try{
                    let json = JSON.parse(this.getCompany().contacts_json);
                    return json[0].email;
                }catch (e) { return ""}
            },

            getCompanyName(){
                try{
                    return this.getCompany().name;
                }catch (e) {
                    return '';
                }
            },

            getClientName(){
                try{
                    return this.getClient().name;
                }catch (e) {
                    return '';
                }
            },

            getClientNif(){
                let res = '';
                try {
                    res = this.getClient().nif;
                }catch (e) {
                    return '';
                }
                return res ? res : 'indefinindo';
            },

            getWhoRegisteredName(){
                try{
                    return this.fetchedInvoiceReceipt.sell.made_by_user.name;
                }catch (e) {
                    return '-';
                }
            },


            getClientCity(){
                try{
                    return this.getClient().city.name;
                }catch (e) { return ''}
            },

            getCompanyPhone(){
                try{
                    return this.getPhone(JSON.parse(this.fetchedInvoiceReceipt.sell.company.contacts_json));
                }catch (e) { return ''}
            },

            getCompanyAddress(){
                try{
                    return 'Endereço: '+this.getCompany().address+', '+this.getCompany().city.name;
                }catch (e) { return ''}

            },

            getCompanyNif(){
                try{
                    return this.getCompany().nif;
                }catch (e) { return ''; }
            },

            getClientPhone(){
                try {
                    let contactsJson = this.getClient().contacts_json;
                    if(!contactsJson) return undefined;
                    return this.getPhone(JSON.parse(contactsJson));
                }catch (e) {
                    return '';
                }

            },

            getClientEmail(){
                try{
                    return this.getEmail(JSON.parse(this.getClient().contacts_json));
                }catch (e) { return ''}
            },

            getCompanyLogo(){
                let res = '';
                // return 'images/logo_lacif4.png';
                try{
                    res = this.loggedUser.group.company.image_path;
                }catch (e) { /*Do nothing*/}

                return res;
            },


            getSubTotal(){
                let res = 0;
                if(!this.sellLines){
                    // this.consoleLog('SellLines in InvoiceReceipt.vue is undefined');
                    return 0;
                }
                for(let i=0; i<this.sellLines.length; i++){
                    // if(myInvoice.payments[i].invoice_receipt.receipt_id === this.selectedReceipt.id)
                    let sellLine = this.sellLines[i];
                    res += (sellLine.sell_price * sellLine.sold_quantity) ;
                }
                return res;
            },

            getTotal(){
                let res = 0;
                if(!this.sellLines){
                    // this.consoleLog('SellLines in InvoiceReceipt.vue is undefined');
                    return 0;
                }
                for(let i=0; i<this.sellLines.length; i++){
                    // if(myInvoice.payments[i].invoice_receipt.receipt_id === this.selectedReceipt.id)
                    let sellLine = this.sellLines[i];
                    let itemValue = sellLine.sell_price - (sellLine.sell_price * sellLine.discount / 100);
                    res += (itemValue * sellLine.sold_quantity);
                }
                return res;
            },

        }
    }
</script>

<style scoped>

    table.a5format, .a5format tr, .a5format th, .a5format td{
        border-color: LightGray;
        border-left: none;
        border-right: none;
        padding-left: 10px;
        padding-right: 10px;
        font-size: 11px;
    }

    table.a4format, .a4format tr, .a4format th, .a4format td{
        border-color: LightGray;
        border-left: none;
        border-right: none;
        padding-left: 10px;
        padding-right: 10px;
        font-size: 14px;
    }

    table th{
        height: 40px;
    }

    table td{
        height: 30px;
    }

    footer {
        position: fixed;
        bottom: 0;
        margin-bottom: 0;
        font-size: 11px;

        /*margin-top: 8mm;*/
    }
</style>
